export class BillingInfo {
  public firstName = '';
  public lastName = '';
  public middleName = '';
  public company = '';
  public email = '';
  public phone = '';
  public address1 = '';
  public address2 = '';
  public city = '';
  public state = null;
  public zip = '';
  public country = null;
  public title = null;
}
